import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaInput } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { useToaster } from "utils";

export const TrainerZoneAdminNotificationEmailForm = ({ email }: { email: string }) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email,
    },
  });

  const onSubmit = async (values: TrainerZoneAdminNotificationEmailValues) => {
    try {
      await settingsApi.saveTrainerZoneAdminNotificationEmail(values);
      await invalidateSettings();
      showSuccess("Zapisano adres powiadomień panelu trenera");
    } catch (error) {
      showError("Błąd podczas zapisywania adresu powiadomień panelu trenera");
    }
  };

  const {
    handleSubmit,
    formState: { isDirty, errors },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col justify-between" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex items-end gap-2">
          <PaziaInput
            label="Adres(y) e-mail powiadomień o plikach trenerów"
            placeholder="np. admin@firma.pl, ksiegowosc@firma.pl"
            name="email"
          />
          <PaziaButton
            type="success"
            disabled={!isDirty}
            title="Zapisz"
            className={errors.email ? "mb-[26px]" : ""}
          />
        </div>
      </form>
    </FormProvider>
  );
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const schema = yup
  .object({
    email: yup
      .string()
      .required()
      .test("valid-emails", "Nieprawidłowy adres e-mail", (value) =>
        (value ?? "")
          .split(/[,;]/)
          .map((address) => address.trim())
          .filter((address) => address.length > 0)
          .every((address) => EMAIL_REGEX.test(address))
      )
      .test("at-least-one", "Podaj co najmniej jeden adres e-mail", (value) =>
        (value ?? "").split(/[,;]/).some((address) => address.trim().length > 0)
      ),
  })
  .required();

export type TrainerZoneAdminNotificationEmailValues = yup.InferType<typeof schema>;
